module.exports = __webpack_public_path__ + "img/744.d688f5ac.jpg";